// Copies text to the clipboard, falling back to a hidden-textarea trick on
// browsers/contexts where the modern Clipboard API isn't available (e.g. non-HTTPS).
export const copyToClipboard = (text, onCopied) => {
  if (!text || text === "Loading...") return;

  const markCopied = () => {
    onCopied(true);
    setTimeout(() => onCopied(false), 2000);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(markCopied)
      .catch(err => {
        console.error('Failed to copy (modern): ', err);
        fallbackCopyToClipboard(text, markCopied);
      });
  } else {
    fallbackCopyToClipboard(text, markCopied);
  }
};

const fallbackCopyToClipboard = (text, markCopied) => {
  try {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Ensure the textarea is off-screen
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      markCopied();
    } else {
      console.error('Fallback copy was unsuccessful');
    }
  } catch (err) {
    console.error('Unable to copy using fallback', err);
  }
};
